import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { AppState } from '@store/app.state';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';

import { GetRenewalActionsFailure, GetRenewalActionsRequest, GetRenewalActionsSuccess } from './actions';
import { GetRenewalActionsService } from './service';
import { getRenewalActionsGetData } from './selectors';

@Injectable()
export class GetRenewalActionsEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store<AppState>);
  private readonly getRenewalActionsService = inject(GetRenewalActionsService);

  getRenewalActions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetRenewalActionsRequest),
      withLatestFrom(this.store.pipe(select(getRenewalActionsGetData))),
      switchMap(([{ parameters }, data]) => {
        if (!data?.length) {
          return this.getRenewalActionsService.getRenewalActions(parameters).pipe(
            map(data => GetRenewalActionsSuccess({ data })),
            catchError(error => of(GetRenewalActionsFailure({ error })))
          );
        }
        return of(GetRenewalActionsSuccess({ data }));
      })
    )
  );

}
